import { gqlRequestType } from '@minecraft.graphql-types';
import { useTranslation } from '@blocs.i18n';
import { FEATURE_FLAGS, useFeatureExperiment } from '@blocs.features-experiments';
import { SelectOption } from '../types';

export const useRequestTypeOptions = (): Array<SelectOption> => {
  const { t } = useTranslation();
  const isSelfTapeStringsEnabled = useFeatureExperiment(FEATURE_FLAGS.WEB_SELF_TAPE_STRINGS);

  return [
    { value: gqlRequestType.AUDITION, label: t('common:role.audition') },
    { value: gqlRequestType.CALLBACK, label: t('common:role.callback') },
    { value: gqlRequestType.ASK_QUESTION, label: t('common:requestType.question') },
    {
      value: gqlRequestType.MEDIA,
      label: t(isSelfTapeStringsEnabled ? 'common:mediaType.mediaSelfTape' : 'common:mediaType.media'),
    },
  ];
};
